/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateSiteSectionRequestSiteSection,
  CreateSiteSectionRequestSiteSectionFromJSON,
  CreateSiteSectionRequestSiteSectionFromJSONTyped,
  CreateSiteSectionRequestSiteSectionToJSON
} from './CreateSiteSectionRequestSiteSection'

/**
 *
 * @export
 * @interface CreateCompanySettingRequestCompanySettingFieldsInner
 */
export interface CreateCompanySettingRequestCompanySettingFieldsInner {
  /**
   *
   * @type {string}
   * @memberof CreateCompanySettingRequestCompanySettingFieldsInner
   */
  name?: string
  /**
   *
   * @type {number}
   * @memberof CreateCompanySettingRequestCompanySettingFieldsInner
   */
  sort?: number
  /**
   *
   * @type {string}
   * @memberof CreateCompanySettingRequestCompanySettingFieldsInner
   */
  kind?: CreateCompanySettingRequestCompanySettingFieldsInnerKindEnum
  /**
   *
   * @type {Array<CreateSiteSectionRequestSiteSection>}
   * @memberof CreateCompanySettingRequestCompanySettingFieldsInner
   */
  companySettingFieldItems?: Array<CreateSiteSectionRequestSiteSection>
}

/**
 * @export
 */
export const CreateCompanySettingRequestCompanySettingFieldsInnerKindEnum = {
  Text: 'text',
  Number: 'number',
  Radio: 'radio',
  Dropdown: 'dropdown',
  Checkbox: 'checkbox',
  Date: 'date',
  Time: 'time'
} as const
export type CreateCompanySettingRequestCompanySettingFieldsInnerKindEnum =
  typeof CreateCompanySettingRequestCompanySettingFieldsInnerKindEnum[keyof typeof CreateCompanySettingRequestCompanySettingFieldsInnerKindEnum]

export function CreateCompanySettingRequestCompanySettingFieldsInnerFromJSON(
  json: any
): CreateCompanySettingRequestCompanySettingFieldsInner {
  return CreateCompanySettingRequestCompanySettingFieldsInnerFromJSONTyped(json, false)
}

export function CreateCompanySettingRequestCompanySettingFieldsInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateCompanySettingRequestCompanySettingFieldsInner {
  if (json === undefined || json === null) {
    return json
  }
  return {
    name: !exists(json, 'name') ? undefined : json['name'],
    sort: !exists(json, 'sort') ? undefined : json['sort'],
    kind: !exists(json, 'kind') ? undefined : json['kind'],
    companySettingFieldItems: !exists(json, 'company_setting_field_items')
      ? undefined
      : (json['company_setting_field_items'] as Array<any>).map(CreateSiteSectionRequestSiteSectionFromJSON)
  }
}

export function CreateCompanySettingRequestCompanySettingFieldsInnerToJSON(
  value?: CreateCompanySettingRequestCompanySettingFieldsInner | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    sort: value.sort,
    kind: value.kind,
    company_setting_field_items:
      value.companySettingFieldItems === undefined
        ? undefined
        : (value.companySettingFieldItems as Array<any>).map(CreateSiteSectionRequestSiteSectionToJSON)
  }
}
